package com.example.readingnotes.data.remote.mapper

import com.example.readingnotes.data.remote.dto.PostTagDto
import com.example.readingnotes.data.remote.dto.TagDto
import com.example.readingnotes.data.remote.dto.TagWithCountDto
import com.example.readingnotes.domain.model.PostTag
import com.example.readingnotes.domain.model.Tag
import com.example.readingnotes.domain.model.TagWithCount
import kotlinx.datetime.Instant

object TagMapper {
    fun toDomain(dto: TagDto): Tag =
        Tag(
            id = dto.id,
            name = dto.name,
            color = dto.color,
            createdAt = Instant.parse(dto.createdAt),
            updatedAt = Instant.parse(dto.updatedAt),
        )

    fun toDomain(dto: PostTagDto): PostTag =
        PostTag(
            postId = dto.postId,
            tagId = dto.tagId,
            createdAt = Instant.parse(dto.createdAt),
        )

    fun toDomain(dto: TagWithCountDto): TagWithCount =
        TagWithCount(
            tag = toDomain(dto.tag),
            postCount = dto.postCount,
        )

    fun toDto(domain: Tag): TagDto =
        TagDto(
            id = domain.id,
            name = domain.name,
            color = domain.color,
            createdAt = domain.createdAt.toString(),
            updatedAt = domain.updatedAt.toString(),
        )

    fun toDto(domain: PostTag): PostTagDto =
        PostTagDto(
            postId = domain.postId,
            tagId = domain.tagId,
            createdAt = domain.createdAt.toString(),
        )
}
